import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { FuseAnimate, FuseUtils } from '@fuse'
import { bindActionCreators } from 'redux'
import { constDataDialogs } from '../../../../constants'
import ReduxGlobal from '../../../../store/actionreducers/globalView'
import ReduxUser from '../../../../store/actionreducers/user'
import ReduxVip from '../../../../store/actionreducers/vip'
import ReduxGroup from '../../../../store/actionreducers/group'
import { UecareStatus } from '../../../../components'
import ReactTable from 'react-table'
import classNames from 'classnames'
import _ from 'lodash'
import { Button, Icon, IconButton, MenuItem, Select, Tooltip, Typography } from '@material-ui/core'
import { account_status, canActivatedStatus, canChoosePlanStatus } from '../../../../constants/status'
import moment from 'moment'

class VipList extends Component {
    state = {
        filterUsageData: [],
    }
    stateUser={
        userName:''
    };

    getFilteredArray = (entities, searchText) => {
        const arr = Object.keys(entities).map((id) => entities[id]);
        if (searchText.length === 0) {
            return arr;
        }
        return FuseUtils.filterArrayByString(arr, searchText);
    };

    onFilteredChange = () => {
        const currentRecords = this.selectTable.getResolvedState().sortedData;
        this.setState({filterUsageData: _.map(currentRecords, '_original')});
    };

    render() {
        const {
            classes, vips, searchText,
            openLoadingMask, openAlertDialog, closeLoadingMask,
            getVip, refreshVips, getUser, disableVip, openDataDialog, getGroup, enableVip, validateVipEmail, removePlan,
            cities, livingArea, user, limit, pricePlanTabs=[] } = this.props

        const newVips = vips.filter(function (vip) {
            return vip.user.user_type === 'vip';
        }).map((vip) => {
            if (!vip.patientFamily) return vip
            if (vip.patientFamily.length === 0) return vip
            const patient = vip.patientFamily[0].patient
            vip.patient_name = patient.patient_name
            vip.patient_personal_id = patient.patient_personal_id
            vip.bed_name = patient.bed.name
            vip.room_name = patient.bed.room.name
            return vip
        })

        const data = this.getFilteredArray(newVips.map(s => ({
            ...s,
            userId: s.user.id,
        })), searchText);

        if (!data && data.length === 0) {
            return (
                <div className="flex items-center justify-center h-full">
                    <Typography color="textSecondary" variant="headline">
                        目前沒有任何會員
                    </Typography>
                </div>
            );
        }
        const tempShhAdminId = [6345]

        return (
            <div>
                <FuseAnimate animation="transition.slideUpIn" delay={300}>
                    <ReactTable
                        sortable={false}
                        showPagination={false}
                        defaultPageSize={limit}
                        pageSize={limit}
                        className={classNames(classes.root, "-striped -highlight")}
                        ref={r => this.selectTable = r}
                        getTrProps={(state, rowInfo) => {
                            return {
                                className: "cursor-pointer",
                                onClick: async () => {
                                    if (rowInfo) {
                                        try {
                                            const vipId = rowInfo.original.id;
                                            await getVip(vipId)
                                            openDataDialog({
                                                type: constDataDialogs.type.edit,
                                                name: constDataDialogs.name.vipDialog
                                            }); // 打開 vipDialog
                                        } catch (e) {
                                            console.warn('you got an error = ', e);
                                        }
                                    }
                                },
                            }
                        }}
                        data={data
                            .sort((a, b) => b.fk_user_id - a.fk_user_id)
                            .map(vip => ({
                                ...vip,
                                userId: `${vip.fk_user_id}`,
                                name: vip.user.name || '-',
                                pid: vip.user.id_no || '-',
                                occNumber: vip.user.occ_number || '-',
                                planName: vip.price_plan ? vip.price_plan.name : '-',
                                email: vip.user.email || '-',
                                phone: vip.user.phone_number ? `+${vip.user.phone_country_code} ${vip.user.phone_number}` : '-',
                                signUpAt: moment(vip.user.created_at).format('YYYY-MM-DD'),
                                livingArea: (vip.fk_living_area_id && livingArea.find(la => la.id === vip.fk_living_area_id) && livingArea.find(la => la.id === vip.fk_living_area_id).name)
                                    || (vip.user.fk_city_id && cities.find(city => city.id === vip.user.fk_city_id) && cities.find(city => city.id === vip.user.fk_city_id).name)
                                    || '-',
                                overseasLivingArea: (vip.user.occ_area_code
                                    && (Object.values(livingArea).find(la => la.ocac_code === vip.user.occ_area_code)
                                    || { name:'-' }).name)
                                    ||'-',
                            }))
                        }
                        columns={[
                            {
                                Header: '使用者編號',
                                accessor: 'userId',
                                width: 100,
                                className: 'justify-center',
                            },
                            {
                                Header: '註冊日期',
                                accessor: 'signUpAt',
                                width: 100,
                                className: 'justify-center',
                            },
                            {
                                Header: '姓名',
                                accessor: 'name',
                                className: 'justify-center',
                                width: 100,
                            },
                            {
                                Header: '身分證字號',
                                accessor: 'pid',
                                width: 100,
                                className: 'justify-center',
                            },
                            {
                                Header: '病人姓名',
                                accessor: 'patient_name',
                                width: 100,
                                className: 'justify-center',
                                show: tempShhAdminId.indexOf(user.id) !== -1,
                            },
                            {
                                Header: '病人身份證號',
                                accessor: 'patient_personal_id',
                                width: 100,
                                className: 'justify-center',
                                show: tempShhAdminId.indexOf(user.id) !== -1,
                            },
                            {
                                Header: '房號',
                                accessor: 'room_name',
                                width: 100,
                                className: 'justify-center',
                                show: tempShhAdminId.indexOf(user.id) !== -1,
                            },
                            {
                                Header: '床號',
                                accessor: 'bed_name',
                                width: 100,
                                className: 'justify-center',
                                show: tempShhAdminId.indexOf(user.id) !== -1,
                            },
                            {
                                Header: '僑胞卡卡號',
                                accessor: 'occNumber',
                                width: 125,
                                className: 'justify-center',
                                Cell: row => {
                                    const {
                                        // id,
                                        user: {
                                            occ_number,
                                            occ_verified_at,
                                        },
                                    } = row.original

                                    const icon = occ_number
                                        && <Icon>{(occ_verified_at ? 'check_circle_outline' : 'error_outline')}</Icon>

                                    return <div className="flex items-center">
                                        {icon}
                                        {row.value}
                                    </div>
                                },
                            },
                            {
                                Header: '居住地區',
                                accessor: 'livingArea',
                                className: 'justify-center',
                                width: 100,
                            },
                            {
                                Header: '僑居地',
                                accessor: 'overseasLivingArea',
                                className: 'justify-center',
                                width: 100,
                                show: tempShhAdminId.indexOf(user.id) === -1,
                            },
                            {
                                Header: '使用方案',
                                accessor: 'planName',
                                className: 'justify-start',
                                width: 100,
                                Cell: row => {
                                    const { userId, price_plan, status, id: vipId } = row.original
                                    if (!price_plan || status.label === account_status.activated.label) return row.value

                                    return <div className="flex items-center">
                                        {row.value}
                                        <Button
                                            onClick={async (ev) => {
                                                ev.stopPropagation()
                                                openAlertDialog({
                                                    title: '移除方案',
                                                    message: `請問您是否要移除使用者編號為 ${userId} 的方案？`,
                                                    yesButton: {
                                                        label: '是',
                                                        onClick: async () => {
                                                            try {
                                                                openLoadingMask()
                                                                await removePlan(vipId)
                                                                await refreshVips()
                                                                closeLoadingMask()
                                                            } catch (e) {
                                                                console.warn('you got an error = ', e)
                                                            }
                                                        },
                                                    },
                                                    noButton: { label: '否' },
                                                })
                                            }}
                                            title="移除方案"
                                        >
                                            <Icon className={'text-teal-darker'}>eject</Icon>
                                        </Button>
                                    </div>
                                },
                            },
                            {
                                Header: 'Email',
                                accessor: 'email',
                                className: 'justify-center',
                                width: 150,
                            },
                            {
                                Header: '手機號碼',
                                accessor: 'phone',
                                className: 'justify-center',
                                width: 125,
                            },
                            {
                                Header: '狀態',
                                accessor: 'status',
                                Cell: row => (<UecareStatus name={row.value.name} label={row.value.label}/>),
                                className: 'justify-center',
                                width: 120,
                                sortMethod: ({ id: a }, { id: b }) => a > b ? 1 : a < b ? -1 : 0,
                            },
                            {
                                Header: () => <div>資訊</div>,
                                width: 64,
                                Cell: row =>
                                    (<div className="flex items-center">
                                        <IconButton
                                            onClick={async (ev) => {
                                                try {
                                                    ev.stopPropagation();
                                                    const groupId = row.original.group.id;
                                                    await getGroup(groupId);
                                                    openDataDialog({
                                                        type: constDataDialogs.type.edit,
                                                        name: constDataDialogs.name.groupDialog
                                                    }); // 打開 groupDialog
                                                } catch (e) {
                                                    console.warn('you got an error = ', e);
                                                }
                                            }}
                                        >
                                            <Icon className={"text-teal-darker"}>group</Icon>
                                        </IconButton>
                                    </div>),
                                show: tempShhAdminId.indexOf(user.id) === -1,
                            },
                            {
                                Header: () => <div>到期日</div>,
                                width: 120,
                                accessor: 'group.expire_date',
                                className: 'justify-center',
                                Cell: row => {
                                    if (!row.value) return '無到期日'
                                    return moment(row.value).format('YYYY-MM-DD')
                                },
                                show: tempShhAdminId.indexOf(user.id) === -1,
                            },
                            {
                                Header: () => <div>驗證</div>,
                                width: 64,
                                Cell: row => {
                                    if (row.original.status.label !== account_status.registered.label) return '';
                                    else return (
                                        <div className="flex items-center">
                                            <IconButton
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    const vip = row.original;
                                                    const alertDialogInfo = {
                                                        title: '驗證電子信箱',
                                                        message: `請問您是否要直接驗證${vip.user.name}的信箱?`,
                                                        yesButton: {
                                                            label: '是',
                                                            onClick: async () => {
                                                                try {
                                                                    openLoadingMask();
                                                                    await validateVipEmail(vip.id);
                                                                    await refreshVips();
                                                                    closeLoadingMask();
                                                                } catch (e) {
                                                                    console.warn('you got an error = ', e);
                                                                }
                                                            },
                                                        },
                                                        noButton: {label: '否'}
                                                    };

                                                    openAlertDialog(alertDialogInfo); // disable VIP
                                                }}
                                            >
                                                <Icon className={"text-teal-darker"}>mail</Icon>
                                            </IconButton>
                                        </div>
                                    );
                                },
                                show: tempShhAdminId.indexOf(user.id) === -1,
                            },
                            {
                                Header: () => <div>訊息</div>,
                                width: 64,
                                Cell: row => {
                                    const {
                                        userId,
                                    } = row.original

                                    return <div className="flex items-center">
                                        <Button
                                            onClick={async (ev) => {
                                                try {
                                                    ev.stopPropagation()
                                                    await getUser(userId)
                                                    openDataDialog({
                                                        type: constDataDialogs.type.new,
                                                        name: constDataDialogs.name.systemEmailDialog,
                                                    })
                                                } catch (e) {
                                                    console.warn('you got an error = ', e)
                                                }
                                            }}
                                        >
                                            <Icon className={"text-teal-darker"}>send</Icon>
                                        </Button>

                                    </div>
                                },
                                show: tempShhAdminId.indexOf(user.id) === -1,
                            },
                            {
                                Header: () => <div>方案</div>,
                                width: 64,
                                Cell: row => {
                                    if (canChoosePlanStatus.includes(row.original.status.label)) {
                                        return (
                                            <div className="flex items-center">
                                                <IconButton
                                                    style={{color: '#e49d00'}}
                                                    onClick={async (ev) => {
                                                        try {
                                                            ev.stopPropagation();
                                                            const vipId = row.original.id;
                                                            await getVip(vipId);
                                                            openDataDialog({
                                                                type: constDataDialogs.type.new,
                                                                name: constDataDialogs.name.joinClubDialog,
                                                                payload: pricePlanTabs
                                                            }); // 打開加入益友頁  --> 選擇方案
                                                        } catch (e) {
                                                            console.warn('you got an error = ', e);
                                                        }
                                                    }}
                                                >
                                                    <Icon style={{color: '#e49d00'}}>monetization_on</Icon>
                                                </IconButton>
                                            </div>
                                        );
                                    } else return <div className="flex items-center"/>;
                                },
                                show: tempShhAdminId.indexOf(user.id) === -1,
                            },
                            {
                                Header: () => <div>開通</div>,
                                width: 64,
                                Cell: row => {
                                     if (canActivatedStatus.includes(row.original.status.label)) {
                                        return (
                                            <Tooltip title="直接開通">
                                                <IconButton
                                                    style={{color: '#851684'}}
                                                    onClick={async (ev) => {
                                                        ev.stopPropagation();
                                                        const vip = row.original;
                                                        const alertDialogInfo = {
                                                            title: '直接開通帳號',
                                                            message: `請問您要直接開通帳號(${vip.user.name})嗎?`,
                                                            yesButton: {
                                                                label: '是',
                                                                onClick: async () => {
                                                                    try {
                                                                        openLoadingMask();
                                                                        const vipId = row.original.id;
                                                                        await enableVip(vipId);
                                                                        await refreshVips();
                                                                        closeLoadingMask();
                                                                    } catch (e) {
                                                                        console.warn('you got an error = ', e);
                                                                    }
                                                                },
                                                            },
                                                            noButton: {label: '否'}
                                                        };

                                                        openAlertDialog(alertDialogInfo); // enable VIP
                                                    }}
                                                >
                                                    <Icon>how_to_reg</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        );
                                    } else return '';
                                }
                            },
                            {
                                Header: () => <div className="text-red-dark font-bold">停用</div>,
                                width: 64,
                                Cell: row => {
                                    if (row.original.status.label === account_status.disabled.label) return '';
                                    else return (
                                        <div className="flex items-center" >
                                            <IconButton
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    const vip = row.original;
                                                    const alertDialogInfo = {
                                                        title: '停用帳號',
                                                        message: `請問您要停用帳號(${vip.user.name})嗎?`,
                                                        yesButton: {
                                                            label: '是',
                                                            onClick: async () => {
                                                                try {
                                                                    openLoadingMask();
                                                                    await disableVip(vip.id);
                                                                    await refreshVips();
                                                                    closeLoadingMask();
                                                                } catch (e) {
                                                                    console.warn('you got an error = ', e);
                                                                }
                                                            },
                                                        },
                                                        noButton: {label: '否'}
                                                    };

                                                    openAlertDialog(alertDialogInfo); // disable VIP
                                                }}
                                            >
                                                <Icon className={"text-teal-darker"}>not_interested</Icon>
                                            </IconButton>
                                        </div>
                                    );
                                }
                            },
                        ]}
                    />
                </FuseAnimate>
            </div>
        );
    }
}

const styles = theme => ({
    mailList: {
        padding: 0
    },
    mailItem: {},
    avatar: {
        backgroundColor: theme.palette.primary[500]
    },
    labels: {},
    tooltip: {
        backgroundColor: '#0abb34',
    },
    info: {
        color: '#00aaff',
    }
});


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getUser: ReduxUser.ActionCreator.getUser,
        getVip: ReduxVip.ActionCreator.getVip,
        refreshVips: ReduxVip.ActionCreator.refreshVips,
        getGroup: ReduxGroup.ActionCreator.getGroup,
        enableVip: ReduxVip.ActionCreator.enableVip,
        disableVip: ReduxVip.ActionCreator.disableVip,
        notifiedVip: ReduxVip.ActionCreator.notifiedVip,
        validateVipEmail: ReduxVip.ActionCreator.validateVipEmail,
        removePlan: ReduxVip.ActionCreator.removePlan,
        // sendSurvey2020: ReduxVip.ActionCreator.sendSurvey2020,
        autoVerifyOcc: ReduxVip.ActionCreator.autoVerifyOcc,
        updateOccVerifyStatus: ReduxVip.ActionCreator.updateOccVerifyStatus,
        openEditDataDialog: ReduxGlobal.ActionCreator.openEditDataDialog,
        openAlertDialog: ReduxGlobal.ActionCreator.openAlertDialog,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch);
}

function mapStateToProps({global: {searchText}, city: { cities, livingArea }, auth}) {
    return {searchText, cities, livingArea, user: auth.user}
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(VipList)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/vip/VipList.js